export default __webpack_public_path__ + "static/media/background.6ed20b2c.png";